import { Box, Checkbox, FormControl } from '@primer/react';
import React, { useState } from 'react';
import { Controller, UseFormSetValue, UseFormTrigger } from 'react-hook-form';
import ComboboxTinh from '../../../components/combobox-tinh';
import { IHocSinh } from '../../../models/response/crm-hocsinh/IHocsinh';
import FormBlock from './FormBlock';
import ComboboxHuyen from '../../../components/combobox-huyen';
import ComboboxXa from '../../../components/combobox-xa';
import TextInput from '../../../components/ui/text-input';
import { ComboboxNguonBietToi } from '../../../components/combobox-nguonbiettoi';
import ComboBoxDieuPhoiVien from '../../../components/combobox-dieuphoivien';
import { useCommonSelectedHook } from '../../../hooks/useCommonSelectedHook';
interface IThongTinKhacProps {
    control: any,
    hocSinh: IHocSinh,
    setFormData: React.Dispatch<React.SetStateAction<IHocSinh>>,
    setValue: UseFormSetValue<IHocSinh>,
    generatedCode?: string,
    register: any,
    errors: any,
    formData: IHocSinh,
    trigger: UseFormTrigger<IHocSinh>,
    canEdit?: boolean
}
const ThongTinKhac = (props: IThongTinKhacProps) => {
    const { control, setFormData, hocSinh, setValue, generatedCode, register, errors, formData, trigger } = props;
    const {dm_coso_id} = useCommonSelectedHook();
    const [selectedProvince, setSelectedProvince] = useState<any>(
        hocSinh.dm_tinh_id || null
    );
    const [selectedDistrict, setSelectedDistrict] = useState<any>(
        hocSinh.dm_huyen_id || null
    );
    const [selectedCommune, setSelectedCommune] = useState<any>(
        hocSinh.dm_xa_id || null
    );
    const handleProvinceChange = (value: any) => {
        setSelectedProvince(value);
        setSelectedDistrict(null);
        setSelectedCommune(null);
        setFormData((prev) => ({
            ...prev,
            dm_tinh_id: value,
            dm_huyen_id: 0,
            dm_xa_id: 0,
        }));
    };
    const handleDistrictChange = (value: any) => {
        setSelectedDistrict(value);
        setSelectedCommune(null);
        setFormData((prev) => ({
            ...prev,
            dm_huyen_id: value,
            dm_xa_id: 0,
        }));
    };
    const handleCommuneChange = (value: any) => {
        setSelectedCommune(value);
        setFormData((prev) => ({
            ...prev,
            dm_xa_id: value,
        }));
    };
    return (
        <FormBlock caption="Thông tin khác">
            <Box sx={{
                display: "grid",
                gap: 2
            }}>
                <Box>
                    <FormControl>
                        <FormControl.Label>Có nhu cầu nội trú</FormControl.Label>
                        <Checkbox checked={formData.is_nhucau_noitru || false}
                            onChange={(e) => {
                                setValue('is_nhucau_noitru', e.target.checked);
                                setFormData(prev => ({
                                    ...prev,
                                    is_nhucau_noitru: e.target.checked
                                }));
                            }}
                        />

                    </FormControl>
                </Box>
                <Box sx={{ display: "grid", gap: 2, gridTemplateColumns: "repeat(4,1fr)" }}>

                    <FormControl>
                        <FormControl.Label>Mã định danh cá nhân</FormControl.Label>
                        <TextInput
                            block
                            name="ma_dinh_danh"
                            register={register}
                            errors={errors}
                            required={false}
                            validateMessage="Vui lòng điền mã định danh"
                        />
                    </FormControl>
                    <FormControl>
                        <FormControl.Label>Mã định danh CSDL</FormControl.Label>
                        <TextInput
                            block
                            name="ma_dinh_danh_csdl"
                            register={register}
                            errors={errors}
                            required={false}
                            validateMessage="Vui lòng điền mã định danh CSDL"
                        />
                    </FormControl>

                    <Controller
                        name="dm_nguonbiettoi_id"
                        control={control}
                        rules={{ required: "Vui lòng chọn nguồn biết tới" }}
                        render={({ field }) => (
                            <>
                                <FormControl>
                                    <FormControl.Label>Nguồn biết tới</FormControl.Label>
                                    <ComboboxNguonBietToi
                                        value={field.value}
                                        onValueChanged={(value) => {
                                            field.onChange(value);
                                            setFormData((prev) => ({
                                                ...prev,
                                                dm_nguonbiettoi_id: value,
                                            }));
                                        }}
                                    />
                                    {errors.dm_nguonbiettoi_id && (
                                        <FormControl.Validation variant="error">
                                            {errors.dm_nguonbiettoi_id.message}
                                        </FormControl.Validation>
                                    )}
                                </FormControl>
                            </>
                        )}
                    />
                    <FormControl>
                        <FormControl.Label>Mã số BHYT</FormControl.Label>
                        <TextInput
                            block
                            name="ma_so_bhyt"
                            register={register}
                            errors={errors}
                            required={false}
                            validateMessage="Vui lòng điền trường học cũ"
                        />
                    </FormControl>


                </Box>
                <Box sx={{ display: "grid", gap: 2, gridTemplateColumns: "1fr 1fr 2fr" }}>
                  <Controller
                        name="dieu_phoi_vien_id"
                        control={control}
                        render={({ field }) => (
                            <>
                                <FormControl>
                                    <FormControl.Label>Điều phối viên</FormControl.Label>
                                    <ComboBoxDieuPhoiVien
                                        role_dpv_id={43}
                                        dm_coso_id={dm_coso_id}
                                        value={field.value}
                                        onValueChanged={(value) => {
                                            field.onChange(value);
                                            setFormData((prev) => ({
                                                ...prev,
                                                dieu_phoi_vien_id: value,
                                            }));
                                        }}
                                    />
                                    {errors.dieu_phoi_vien_id && (
                                        <FormControl.Validation variant="error">
                                            {errors.dieu_phoi_vien_id.message}
                                        </FormControl.Validation>
                                    )}
                                </FormControl>
                            </>
                        )}
                    />
                    <FormControl>
                        <FormControl.Label>Trường cũ</FormControl.Label>
                        <TextInput
                            block
                            name="truong_hoc_cu"
                            register={register}
                            errors={errors}
                            required={false}
                        />
                    </FormControl>
                    <FormControl>
                        <FormControl.Label>Ghi chú chung</FormControl.Label>
                        <TextInput
                            block
                            name="ghi_chu_chung"
                            register={register}
                            errors={errors}
                            required={false}
                        />
                    </FormControl>

                </Box>

            </Box>
        </FormBlock>
    );
};

export default ThongTinKhac;